import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { UploadFileControl } from '@portal/upload-file/data-access';
import { PortalFieldTypeConfig } from '@portal/form/data-access';
import { ControlComponent } from '@portal/upload-file/control';
import { MatIconModule } from '@angular/material/icon';
import { NgIf } from '@angular/common';
import { CyTestDirective } from '@portal/directive';
import { FormlyModule } from '@ngx-formly/core';

@Component({
  selector: 'portal-form-upload-file-control',
  standalone: true,
  imports: [ControlComponent, MatIconModule, NgIf, CyTestDirective, ReactiveFormsModule, FormlyModule],
  template: `
    <label
      [tabIndex]="props.tabindex"
      class="field-file-wrapper"
      [class.field-invalid]="showError"
      [portalCyTest]="field.key"
    >
      <span class="flex items-center justify-center">
        <mat-icon class="field-file-prefix">add_circle_outline</mat-icon>
      </span>
      <span class="break-words">Tap here to upload another file</span>

      <portal-upload-file-control
        [name]="field.name"
        [id]="id"
        [multiple]="props.multiple"
        [formControl]="control"
        [formlyAttributes]="field"
        [acceptMineTypes]="acceptMineTypes"
      ></portal-upload-file-control>
    </label>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadFileControlComponent {
  @Input() acceptMineTypes!: string[];
  @Input() control!: FormControl<UploadFileControl | undefined | null>;
  @Input() field!: PortalFieldTypeConfig;
  @Input() id!: string;
  @Input() props!: NonNullable<PortalFieldTypeConfig['props']>;
  @Input() showError!: boolean;
}
